import { render, staticRenderFns } from "./popWindow.vue?vue&type=template&id=0e8ca0b0&scoped=true"
import script from "./popWindow.vue?vue&type=script&lang=js"
export * from "./popWindow.vue?vue&type=script&lang=js"
import style0 from "./popWindow.vue?vue&type=style&index=0&id=0e8ca0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ca0b0",
  null
  
)

export default component.exports